import React, { useContext, useState } from 'react';
import { Label, FieldControl } from '@americanexpress/dls-react';
import { Input, Alert } from '@americanexpress/dls-react';
import UserContext from '../ContextComponent/UserContext';

function Email({ type, title }) {
    const [emailError, setEmailError] = useState(false);
    const { formData, setFormData } = useContext(UserContext);
    const {errorData, setErrorData} = useContext(UserContext);
    const validateEmail = (e) => {
        var email = e.target.value;
        if(email === '' && type === "PersonalEmail") {
            setErrorData({ ...errorData, emailRequired: true });
        }
        else if(email === '' && type === "CompanyEmail") {
            setErrorData({ ...errorData, companyEmailRequired: true });
        }
        else if( type === "SchoolEmail" && email === "") {
            setErrorData({ ...errorData, schoolEmailRequired: true });
        }
        else {
            setErrorData({ ...errorData, emailRequired: false, companyEmailRequired: false, schoolEmailRequired: false});
        }
        if (email !== '') {
            const pattern = /^([\w.-]+)@([\w-]+)((\.(\w){2,3})+)$/g;
            const result = !pattern.test(email);
            setEmailError(result);
            setErrorData({ ...errorData, emailRequired: false, companyEmailRequired: false, schoolEmailRequired: false});
        }        
    }
    const setValue = (e) => {
        if (type === 'PersonalEmail') {
            setFormData({ ...formData, email: e.target.value })
        }
        else if (type === 'CompanyEmail') {
            setFormData({ ...formData, companyEmail: e.target.value })
        }
        else if (type === 'SchoolEmail') {
            setFormData({ ...formData, schoolEmail: e.target.value })
        }
    }
    return <>
        <FieldControl>
            <Label id={`${type}-label`} htmlFor={`${type}Id`} className="label-1">{title}</Label>
            <Input
                id={`${type}Id`}
                maxLength={60}
                aria-labelledby={`${type}Id-label ${type}Id-alert`} onBlur={(e) => validateEmail(e)}
                onChange = {setValue}
                value={type === "PersonalEmail"? formData.email : (type === "CompanyEmail"? formData.companyEmail : formData.schoolEmail)}
            />
        </FieldControl>
        { type === "PersonalEmail" &&
            <Alert id={`${type}Id-alert`} show={errorData.emailRequired}>Please enter email address</Alert>
        }
        { type === "SchoolEmail" &&
            <Alert id="schoolalert" show={errorData.schoolEmailRequired}>Please enter school email address</Alert>
        }
        { type === "CompanyEmail" &&
            <Alert id="companyalert" show={errorData.companyEmailRequired}>Please enter company email address</Alert>
        }
        <Alert id={`${type}Invalid-alert`} show={emailError}>Please ensure email address is in the correct format (ie. account@domain).</Alert>
    </>;
}

export default Email;